// Tabs with unsaved changes (e.g. a quote being edited) — AppShell asks before closing them
const dirty = new Set();

export const setTabDirty = (tabId, isDirty) => { if (isDirty) dirty.add(tabId); else dirty.delete(tabId); };
export const isTabDirty  = (tabId) => dirty.has(tabId);
